import { LegalClientTargetedFinancialInstrumentsParam } from 'api/types/params';

import { TargetedFinancialInstrumentsFormType } from '../../forms/targetedFinancialInstrumentsForm';

const parseFinancialInstruments = (
  v: TargetedFinancialInstrumentsFormType['targetedFinancialInstruments']['financialInstruments']['bonds']
) =>
  v?.enabled
    ? {
        monthlyTradeAmount: v?.monthlyTradeAmount,
        yearlyTradeAmount: v.yearlyTradeAmount!,
      }
    : undefined;

export const getTargetedFinancialInstrumentsParam = (
  values: TargetedFinancialInstrumentsFormType
): LegalClientTargetedFinancialInstrumentsParam => ({
  financialInstruments: {
    bonds: parseFinancialInstruments(
      values.targetedFinancialInstruments.financialInstruments?.bonds
    ),
    derivatives: parseFinancialInstruments(
      values.targetedFinancialInstruments.financialInstruments?.derivatives
    ),
    mutualFunds: parseFinancialInstruments(
      values.targetedFinancialInstruments.financialInstruments?.mutualFunds
    ),
    stocks: parseFinancialInstruments(
      values.targetedFinancialInstruments.financialInstruments?.stocks
    ),
    structuredProducts: parseFinancialInstruments(
      values.targetedFinancialInstruments.financialInstruments
        ?.structuredProducts
    ),
    otherFinancialInstruments: parseFinancialInstruments(
      values.targetedFinancialInstruments.financialInstruments
        ?.otherFinancialInstruments
    ),
  },
  operationsDetails: {
    expectedMonthlyTradeQuantity:
      values.targetedFinancialInstruments.expectedMonthlyTradeQuantity!,
    expectedYearlyTradeQuantity:
      values.targetedFinancialInstruments.expectedYearlyTradeQuantity!,
  },
});
